import { cookie } from '@zz-common/zz-utils'
import { versionCompare } from './index'

// $ 图文视频预览
export const getCheckBigImageList = ({ indicatorGroup, qcCode }) => {
  const currentV = cookie.get('v') || '9.13.1'
  const isZero = versionCompare(currentV, '9.12.0') >= 0 ? 0 : 1
  const tabList = []
  indicatorGroup.forEach((group, i) => {
    const imgList = JSON.parse(JSON.stringify(group.data))
    const imgDataList =
      group.imgDataList && group.imgDataList.length
        ? JSON.parse(JSON.stringify(group.imgDataList))
        : []
    // const reg = /(http|https):\/\/([\w.]+\/?)\S*/
    // const newArrImageList = imgList
    //   .map((i) => setPicSize(i, 1000, 1000))
    //   .map((item) => {
    //     const { pathname } = new URL(reg.test(item) ? item : 'https:' + item)
    //     item = 'https://opic1.zhuanstatic.com' + pathname
    //     return item
    //   })
    // // 用forEach遍历, 了解一下map和forEach的区别！！！！！
    // imgDataList.forEach((item, index) => {
    //   item.url = newArrImageList[index]
    // })
    //质检码
    // 基础参数
    const baseObj = {
      tabName: group.subtitle,
      name: group.title,
      imgList: imgList,
      originalLoadable: isZero,
    }
    //质检弹窗基础url
    const baseUrl =
      'https://m.zhuanzhuan.com/u/micro_detail/qualitySurvey?webShowType=1&pHeight=60&radius=32&needHideHead=3&hiddenProgress=1&'
    if (group.title == '实拍图') {
      tabList.push({
        ...baseObj,
        // 实拍图对应的反馈入口参数, 每张实拍图对应的jumpurl相同(因为实拍图没有一二三级质检项id)
        actionButton: {
          text: '反馈',
          jumpUrl: `${baseUrl}qcCode=${qcCode}&channelId=3`,
        },
      })
    } else {
      const collectObj = group.itemIds
      const actionButtonWithIndex = []
      for (const i in collectObj) {
        const item = collectObj[i]
        // 细节图对应的一二三级质检项
        const [firstItemId = '', secondItemId = '', thirdItemId = ''] = item
        // 细节图对应的反馈入口参数, 每张细节图对应的jumpurl不一致, 因为每张细节图的一二三级质检项id不一样
        actionButtonWithIndex.push({
          imgIndex: Number(i),
          text: '反馈',
          jumpUrl: `${baseUrl}qcCode=${qcCode}&firstItemId=${firstItemId}&secondItemId=${secondItemId}&thirdItemId=${thirdItemId}&channelId=2`,
        })
      }
      tabList.push({
        ...baseObj,
        imgDataList,
        actionButtonWithIndex,
      })
    }
  })
  return tabList
}
